<template>
    <div class="w-full border mt-2">
        <table class="w-full border-collapse border border-theme-border">
            <thead>
                <tr class="bg-theme-canvas text-theme-base">
                    <th
                        class="w-1/2 py-4 border border-theme-border text-center"
                    >
                        <div class="flex justify-center items-center">
                            <span>{{ nameLabel }}</span>
                        </div>
                    </th>
                    <th
                        class="w-1/2 py-4 border border-theme-border text-center"
                    >
                        <div class="flex justify-center items-center">
                            <span>{{ valueLabel }}</span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="itemsEmptyMessage && itemsCurrent.length === 0">
                    <td
                        colspan="3"
                        class="text-center py-3 text-theme-base text-lg border border-theme-border"
                    >
                        {{ itemsEmptyMessage }}
                    </td>
                </tr>

                <tr v-for="(item, index) in itemsCurrent" :key="index">
                    <th
                        class="text-center font-normal border border-theme-border p-2"
                    >
                        <custom-input
                            v-model="item.name"
                            type="text"
                            class="w-full bg-theme-canvas text-theme-base"
                            autocomplete="off"
                            :disabled="!enabled"
                            @blur="onChange"
                        />
                    </th>
                    <th class="border border-theme-border p-2">
                        <custom-input
                            v-model="item.value"
                            type="text"
                            class="w-full bg-theme-canvas text-theme-base"
                            autocomplete="off"
                            :disabled="!enabled"
                            @blur="onChange"
                        />
                    </th>
                    <th
                        v-if="enabled"
                        class="p-0 m-0 border border-theme-border"
                    >
                        <button
                            class="flex p-0 h-20 items-center justify-center bg-transparent border-0 text-theme-danger hover:opacity-80"
                            @click="deleteItem(index)"
                        >
                            <small> ❌ </small>
                        </button>
                    </th>
                </tr>
            </tbody>
        </table>

        <div v-if="enabled" class="flex justify-center">
            <app-button icon border @click="addNewItem"> ➕ </app-button>
        </div>
    </div>
</template>

<script>
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "FeatureManage",
    components: { CustomInput },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Array,
            default: () => [{ name: "", value: "" }],
            required: true
        },
        itemsEmptyMessage: {
            type: String,
            default: () => "No hay elementos para mostrar",
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        valueLabel: {
            default: () => "Valor",
            type: String,
            required: false
        },
        nameLabel: {
            default: () => "Nombre",
            type: String,
            required: false
        }
    },
    emits: ["change"],
    mounted() {
        this.setInput(this.itemsCurrent);
    },
    methods: {
        addNewItem() {
            let itemsResult = [...this.itemsCurrent];
            itemsResult.push({ name: "", value: "" });
            this.$emit("change", itemsResult);
        },
        onChange() {
            this.$emit("change", this.itemsCurrent);
        },
        deleteItem(fromIndex) {
            let itemsResult = [...this.itemsCurrent];
            itemsResult.splice(fromIndex, 1);
            this.$emit("change", itemsResult);
        },
        setInput(value) {
            let itemsResult = [...value];
            if (!Array.isArray(itemsResult)) {
                itemsResult = [];
            }
            this.$emit("change", itemsResult);
        }
    }
};
</script>
